import { batch } from 'react-redux';
import {
  clearDirectorRequest,
  muteAudio,
  setDirectorControls,
  setDirectorRequestMessage,
  unmuteAudio
} from '../Broadcast';
import { MUTE } from 'constants/DirectorControls';

/** Action creator to handle mute status */
function handleMuteStatus(isMuted) {
  return (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();
    const muteAction = isMuted ? muteAudio(true, true) : unmuteAudio(true);

    if (!isMuted) {
      meetingSession.audioVideo.realtimeSetCanUnmuteLocalAudio(true);
    }

    batch(() => {
      dispatch(muteAction);
      dispatch(
        setDirectorControls({
          key: MUTE,
          value: !isMuted
        })
      );

      dispatch(clearDirectorRequest({ requestType: MUTE }));
      dispatch(
        setDirectorRequestMessage({
          key: MUTE,
          value: null
        })
      );
    });
  };
}

export default handleMuteStatus;
